export const statusOptionsOrder = [
  // { label: 'At Store', value: 'At Store' },
  { label: 'Processing', value: 'Processing' },
  { label: 'Delayed', value: 'Delayed' },
  { label: 'Ready for Delivery', value: 'Ready for Delivery' }
];

export const CustomerTagOptions = [
  { label: 'VIP', value: 'VIP' },
  { label: 'NEW', value: 'NEW' },
  { label: 'AT RISK', value: 'AT_RISK' }
];

export const statusOptionsWeekly = [
  { label: 'Open', value: 'open' },
  { label: 'Closed', value: 'closed' },
];

export const statusCampaign = [
  { label: 'Active', value: 'active' },
  { label: 'Inactive', value: 'inactive' },
  // { label: 'Ended', value: 'ended' },
  // { label: 'Pause', value: 'pause' },

];